function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var l = function l() {
  var l = [].slice.call(arguments);
  return l.unshift(!1), t.apply(null, l);
};

function t() {
  var t = [].slice.call(arguments),
      e = t[0],
      n = {};
  return t.slice(1, t.length).forEach(function (r) {
    Object.keys(r).forEach(function (a) {
      if (!e || void 0 !== t[1][a]) {
        var c = r[a];
        n[a] = Array.isArray(c) || "object" != _typeof(c) || "object" != _typeof(n[a]) ? c : (e ? l.defaults : l)(n[a], c);
      }
    });
  }), n;
}

l.defaults = function () {
  var l = [].slice.call(arguments);
  return l.unshift(!0), t.apply(null, l);
};

export default l;